import {
  ADD_VIDEO_CONTENT,
  FETCH_VIDEO_CONTENT_BY_ID,
  FETCH_VIDEO_CONTENTS,
  REMOVE_VIDEO_CONTENT,
  UPDATE_VIDEO_CONTENT,
  VIDEO_CONTENT_ACTION_STATUS
} from '../actionTypes'

const initialState = {}

export default function (state = initialState, action) {
  switch (action.type) {
    case FETCH_VIDEO_CONTENTS:
      return {
        ...state,
        ...action.payload
      }
    case FETCH_VIDEO_CONTENT_BY_ID:
      return {
        ...state,
        ...action.payload
      }
    case ADD_VIDEO_CONTENT:
      return {
        ...state,
        ...action.payload
      }
    case UPDATE_VIDEO_CONTENT:
      return {
        ...state,
        ...action.payload
      }
    case REMOVE_VIDEO_CONTENT:
      return {
        ...state,
        ...action.payload
      }
    case VIDEO_CONTENT_ACTION_STATUS:
      return {
        ...state,
        ...action.payload
      }
    default:
      return state
  }
}
